import Projects1 from "./Projects1";

const projects = {
    1: Projects1
};

export default projects;